import { useEffect } from 'react';
import { useLayout } from './Layout/LayoutProvider';
import './Spinner.css';

interface TestProps {
    small?: boolean;
}

export default function Spinner({small}: TestProps) {
        const { setLoading } = useLayout();
        useEffect(() => {
            if(!small){
                setLoading(true);
                return () => {
                    setLoading(false);
                }
            }
        }, []);

        if(small){
            return(<div className="loader" />)
        }
       

    
}


